import { render, staticRenderFns } from "./LanguageSelectorPublic.vue?vue&type=template&id=22d594c3&scoped=true"
import script from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorPublic.vue?vue&type=style&index=0&id=22d594c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d594c3",
  null
  
)

export default component.exports